import React, { Fragment } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import { Appeal } from '../../components/appeal/AppealContent';
import { AppealHeader } from '../../components/appeal/AppealHeader';
import { PageTitleComponent } from '../../components/PageTitleComponent';

export default class AppealContainer extends React.PureComponent {
  componentDidMount() {
    const { getAppeal } = this.props;
    getAppeal();
  }

  render() {
    const {
      user,
      tokens,
      appeal,
      downloadFile,
      downloadAllFiles,
      types,
      errorMessage,
      loading
    } = this.props;
    const { cardIndexCode } = appeal;

    return (
      <Fragment>
        <PageTitleComponent title={`Обращение № ${appeal.missionId || ''}`}/>
        <Header user={user} tokens={tokens} />
        <AppealHeader
          title={appeal && appeal.cardIndexName ? appeal.cardIndexName : ''}
          types={types}
          cardIndexCode={cardIndexCode}
        />
        <Appeal
          appeal={appeal}
          downloadFile={downloadFile}
          downloadAllFiles={downloadAllFiles}
          errorMessage={errorMessage}
          loading={loading}
        />
        <Footer />
      </Fragment>
    );
  }
}
